import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "../../../utils/withRouter";
import { DateRange } from "react-date-range";
import { fill_action } from "../../../actions/fillList_action";
import "react-toastify/dist/ReactToastify.css";
import Loader from "../../../utils/Loader";
import Header from "../../../common_components/Header";
import moment from "moment";
import "react-date-range/dist/styles.css"; // main style file
import Pagination from "../../../utils/pagination";
import "react-date-range/dist/theme/default.css"; // theme css file
import { getThirdPartyOrdersList_action } from "../../../actions/accounts_action/account_third_party_orders_action";
import { toast } from "react-toastify";
import { sessionExpireMessage, tokenInavlidMessage } from "../../../utils/constants";
class ThirdPartyOrdersList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      isAccordionExpanded: false,
      currentPage: 1,
      fromDate: "",
      toDate: "",
      ServiceName: '',
      VendorName: '',
      OrderNo: "",
      dateRange: [
        {
          startDate: new Date(),
          endDate: new Date(),
          key: "selection",
        },
      ],
      thirdPartyOrderList: [],
      roleID: '',
    };
    this.record = this.record.bind(this);
    this.chooseDate = this.chooseDate.bind(this);
    this.getThirdPartyOrdersList = this.getThirdPartyOrdersList.bind(this);
    this.navigateDetails = this.navigateDetails.bind(this);
    this.updateItem = this.updateItem.bind(this);
    this.clearFilters = this.clearFilters.bind(this);

  }

  componentDidMount() {
    this.getThirdPartyOrdersList();
    this.setState({ roleID: sessionStorage.getItem('roleId') })
    console.log(sessionStorage.getItem('roleId'))
  }

  navigateDetails(OrderID, ServiceID, VendorID) {
    this.props.navigate("/thirdPartyOrderAU", {
      state: {
        OrderID: OrderID,
        ServiceID: ServiceID,
        VendorID: VendorID
      }
    })
  }

  record(list) {
    const { roleID } = this.state
    return (
      <table class="table table-bordered table-striped" id="dashboard-table">
        <thead>
          <tr>
            <th className="text-center">APPLICATION NO</th>
            <th className="text-center">ORDER NUMBER</th>
            <th className="text-center">BOOKING DATE</th>
            {/* <th className="text-center">ORGANIZER NAME</th>
            <th className="text-center">ORGANIZER CONTACT DETAILS</th> */}
            <th className="text-center">SERVICE</th>
            {roleID == 2 && <th className="text-center">VENDOR NAME</th>}
            <th style={{ width: "50px" }}>ACTION</th>
          </tr>
        </thead>
        <tbody>
          {list?.length > 0 ? (
            <>
              {list?.map((data, i) => (
                <tr key={Math.random()}>
                  <td className="text-center">{data.OrderID}</td>
                  <td className="text-center">{data.OrderNo}</td>
                  <td className="text-center">{data.BookingDate}</td>
                  {/* <td className="text-center">{data.OrganizorName}</td>
                  <td className="text-center">
                    {data.OrganizorContactDetails}
                  </td> */}
                  <td className="text-center">
                    {data.ServiceName}
                  </td>
                  {roleID == 2 &&
                    <td className="text-center">
                      {data.VendorName}
                    </td>}
                  <td className="text-center">
                    <a
                      href="javascript:void(0);"
                      title="View"
                      onClick={(e) => this.navigateDetails(data.OrderID, data.ServiceID, data.VendorID)}
                    >
                      {" "}
                      <span
                        className={
                          data.Action === "Incomplete"
                            ? "badge_soft_secondary"
                            : data.Action === "Open"
                              ? "badge_soft_success"
                              : data.Action === "Cancelled"
                                ? "badge_soft_danger"
                                : data.Action === "Cancellation Request"
                                  ? "badge_soft_warning"
                                  : "badge_soft_done"
                        }
                      >
                        {data.Action === "Pending for Verification" ? "Pending for Action" : data.Action}
                      </span>
                    </a>
                  </td>
                </tr>
              ))}
            </>
          ) : (
            <tr>
              <td colSpan={13} style={{ textAlign: "center" }}>
                Record not found
              </td>
            </tr>
          )}
        </tbody>
      </table>
    );
  }

  updateItem(item) {
    console.log("updateItem : ", item);
    this.setState({ currentPage: item });
  }

  chooseDate(item) {
    this.setState({ dateRange: [item.selection] });
    console.log(item, item.selection);
    this.setState({
      fromDate:
        item.selection["startDate"] != null ? (
          moment(item.selection["startDate"]).format("YYYY-MM-DD")
        ) : (
          <></>
        ),
      toDate:
        item.selection["endDate"] != null ? (
          moment(item.selection["endDate"]).format("YYYY-MM-DD")
        ) : (
          <></>
        ),
    });
    console.log(moment(item.selection["startDate"]).format("YYYY-MM-DD"), moment(item.selection["endDate"]).format("YYYY-MM-DD"))
  }

  getThirdPartyOrdersList() {
    const { userId, orderId, OrderNo, fromDate, toDate, ServiceName, VendorName } = this.state;
    this.setState({ isLoading: true });
    console.log(fromDate, toDate)
    this.props
      .getThirdPartyOrdersList_action(OrderNo, fromDate, toDate, ServiceName, VendorName)
      .then((data) => {
        console.log(data, 'oo');
        if (data.error !== 1) {
          this.setState({ thirdPartyOrderList: data.data });
          this.setState({ isLoading: false });
        } else {
          if (data.msg == sessionExpireMessage || data.msg == tokenInavlidMessage) {
            //after session expire.....................
            sessionStorage.clear()
            this.props.navigate('/normalView')
            setTimeout(() => {
              toast.error(data.msg, {
                position: "top-center",
                theme: "colored",
                autoClose: 3000,
                hideProgressBar: true,
              });
            }, 500);
          } else {
            toast.error(data.msg, {
              position: "top-center",
              theme: "colored",
              autoClose: 1000,
              hideProgressBar: true
            })
          }
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }

  clearFilters() {
    this.setState({
      fromDate: '',
      toDate: '',
      ServiceName: '',
      VendorName: '',
      OrderNo: '',
      currentPage: 1,
    })
    setTimeout(() => {
      this.getThirdPartyOrdersList()
    }, 200);
  }

  render() {
    const {
      isLoading,
      isAccordionExpanded,
      fromDate,
      toDate,
      ServiceName,
      VendorName,
      OrderNo,
      thirdPartyOrderList,
      currentPage, roleID
    } = this.state;
    const recordsPerPage = 10;
    const indexOfLastRecord = currentPage * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
    const currentRecords = thirdPartyOrderList?.length > 0 ? thirdPartyOrderList?.slice(
      indexOfFirstRecord,
      indexOfLastRecord
    ) : [];
    const nPages = Math.ceil(thirdPartyOrderList?.length / recordsPerPage);
    console.log(currentRecords, 'pppp', thirdPartyOrderList)
    return (
      <>
        {isLoading ? <Loader></Loader> : null}
        <>
          <main id="main">
            <Header data={[18]} />

            <section style={{ marginTop: 115 }}>
              <div className="container-fluid">
                <div className="page-header">
                  <h4 className="page-title">{roleID == 13 ? "Client Orders" : "Third Party Orders"}</h4>
                </div>
                <div className="search_accordion search_card">
                  <div className="panel-group" id="accordion">
                    <div className="panel panel-default">
                      <div
                        className="panel-heading accordion-toggle collapsed"
                        data-toggle="collapse"
                        data-parent="#accordion"
                        data-target="#collapseOne"
                        aria-expanded={isAccordionExpanded}
                        onClick={() =>
                          this.setState({
                            isAccordionExpanded: !isAccordionExpanded,
                          })
                        }
                      >
                        <h4 className="panel-title">Search</h4>
                        <div className="searched_items">
                          <h5>
                            Order Date :{" "}
                            <span>
                              {fromDate != "" && fromDate != "null" ? (
                                moment(fromDate).format("DD-MM-YYYY")
                              ) : (
                                <></>
                              )}{" "}
                              &nbsp; - &nbsp;
                              {toDate != "" && toDate != "null" ? (
                                moment(toDate).format("DD-MM-YYYY")
                              ) : (
                                <></>
                              )}
                            </span>
                          </h5>
                          <h5>
                            OrderNo:
                            <span>{OrderNo}</span>
                          </h5>
                          <h5>
                            Service Name : <span>{ServiceName}</span>
                          </h5>
                          <h5>
                            Vendor Name : <span>{VendorName}</span>
                          </h5>
                        </div>
                      </div>
                      <div
                        id="collapseOne"
                        className={`panel-collapse collapse ${isAccordionExpanded ? "show" : ""
                          }`}
                        aria-labelledby="headingOne"
                      >
                        <div className="panel-body">
                          <div className="row mr_0">
                            <div className="col-md-3">
                              <div className="form-group">
                                <label>Order Date</label>
                                <DateRange
                                  editableDateInputs={true}
                                  onChange={(item) => this.chooseDate(item)}
                                  moveRangeOnFirstSelection={false}
                                  ranges={this.state.dateRange}
                                />
                              </div>
                            </div>
                            <div className="col-md-2">
                              <div className="form-group">
                                <label>Order No</label>
                                <input
                                  value={OrderNo}
                                  type="text"
                                  onChange={(e) =>
                                    this.setState({
                                      OrderNo: e.target.value,
                                    })
                                  }
                                  className="form-control search_form_control"
                                  id="search"
                                  placeholder="Search for Order No"
                                />
                              </div>
                            </div>
                            <div className="col-md-2">
                              <div className="form-group">
                                <label>Service Name</label>
                                <input
                                  value={ServiceName}
                                  type="text"
                                  onChange={(e) =>
                                    this.setState({
                                      ServiceName: e.target.value,
                                    })
                                  }
                                  className="form-control search_form_control"
                                  id="search"
                                  placeholder="Search for Service Name"
                                />
                              </div>
                            </div>
                            <div className="col-md-2">
                              <div className="form-group">
                                <label>Vendor Name</label>
                                <input
                                  value={VendorName}
                                  type="text"
                                  onChange={(e) =>
                                    this.setState({
                                      VendorName: e.target.value,
                                    })
                                  }
                                  className="form-control search_form_control"
                                  id="search"
                                  placeholder="Search for Company Name"
                                />
                              </div>
                            </div>
                            <div className="col-md-4">
                              <label>&nbsp;</label>
                              <button
                                onClick={() => this.getThirdPartyOrdersList()}
                                className="btn btn-primary search_btn"
                              >
                                <i className="fa fa-sliders" />
                                Filter
                              </button>
                              &nbsp;
                              <button
                                onClick={() => this.clearFilters()}
                                className="btn btn-primary search_btn"
                              >
                                <i className="fa fa-times" />
                                Clear Filters
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="custom_table d-flex">
                  <div className="hack1">
                    <div class="hack2">{this.record(currentRecords)}
                      {thirdPartyOrderList?.length > 0 ? (
                        <Pagination
                          nPages={nPages}
                          currentPage={currentPage}
                          setCurrentPage={this.updateItem}
                        />
                      ) : (
                        <></>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </main>
        </>
      </>
    );
  }
}
export default withRouter(
  connect(null, { fill_action, getThirdPartyOrdersList_action })(
    ThirdPartyOrdersList
  )
);
